import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { ICurrency } from 'src/app/shared/model/currency.model';
import { PaymentService, UtilService, VariablesService } from 'src/app/shared/services';
import { CurrencyComponent } from '../currency/currency.component';
import { RippleDirective } from 'src/app/shared/directives/ripple.directive';
import { IconComponent } from '../icon/icon.component';
@Component({
  selector: 'app-currency-dropdown',
  imports: [
    MatMenuModule,
    RippleDirective,
    CurrencyComponent,
    IconComponent
  ],
  templateUrl: './currency-dropdown.component.html',
  styleUrls: ['./currency-dropdown.component.scss']
})
export class CurrencyDropdownComponent implements OnInit {
  vars = inject(VariablesService);
  utils = inject(UtilService);
  readonly payments = inject(PaymentService);


  @Input() type: 'symbol' | 'text' = 'symbol';
  @Input() theme: '' | 'theme1' | 'theme2' | 'theme3' = '';
  @Input() selectedCurrency?: string;
  @Input() currencyList?: ICurrency[];

  @Output() onCurrencyChange = new EventEmitter()

  ngOnInit(): void {
    if (!this.selectedCurrency) {
      this.selectedCurrency = this.vars.currency;
    }
  }

  setCurrency(currency?: string) {
    this.selectedCurrency = currency;
    this.onCurrencyChange.emit(currency);
  }
}
